import React from 'react';
import { Typography, Paper, Box, Divider } from '@mui/material';
import { Business } from '@mui/icons-material';
import {
  PermissionGate,
  Permissions,
  usePermission,
} from '@billda/permissions-ui';
import { CompanyDetailsForm } from '../../../features/organisation/components/CompanyDetailsForm';

/**
 * Organisation settings area: company details for invoices.
 */
export const OrganisationArea: React.FC = () => {
  const canManage = usePermission(Permissions.Organisation.Details.Manage);

  return (
    <PermissionGate
      permission={Permissions.Organisation.Details.Read}
      showRequiredPermissions={false}
    >
      <Paper sx={{ p: 3, mb: 3 }} data-testid="organisation-section">
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Business sx={{ mr: 1, color: 'primary.main' }} />
          <Typography variant="h6">Organisation</Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {canManage
            ? "Manage your organisation's company details for invoices."
            : "Your organisation's company details used for invoices."}
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <CompanyDetailsForm readOnly={!canManage} />
      </Paper>
    </PermissionGate>
  );
};
